export const insuranceReportTrackingIds = {
  addPayerConnectionButton: 'insurance-report:add-payer-connection-button',
  inlineReportVisible: 'insurance-report:inline-report-visible',
};
